import { BATTERY_PART_TYPE } from './constants';
import type { GetIntervalUnits, IntervalUnit } from './types';

const BATTERY_UNITS: IntervalUnit[] = ['CYCLES'];

const WEAR_PART_UNITS: IntervalUnit[] = ['FLIGHTS', 'HOURS'];

// The GET response reports only the unit in effect, so FR-29's unit rule is mirrored here.
const getIntervalUnits: GetIntervalUnits = ({ partType }) =>
    partType === BATTERY_PART_TYPE ? BATTERY_UNITS : WEAR_PART_UNITS;

export default getIntervalUnits;
